import { ApiClientError } from '@/api/client';

/** Guards against ever rendering the literal generic-500 fallback text verbatim. */
export function sanitizeErrorMessage(message: string, fallback: string): string {
  const trimmed = message.trim();
  if (!trimmed || trimmed.toLowerCase() === 'internal server error') return fallback;
  return message;
}

export function formatIntakeError(err: unknown, fallback: string): string {
  if (err instanceof ApiClientError) return sanitizeErrorMessage(err.message, fallback);
  if (err instanceof Error) return sanitizeErrorMessage(err.message, fallback);
  return fallback;
}
